import { render, staticRenderFns } from "./ViewDetails.vue?vue&type=template&id=243d8da4"
import script from "./ViewDetails.vue?vue&type=script&lang=js"
export * from "./ViewDetails.vue?vue&type=script&lang=js"
import style0 from "./ViewDetails.vue?vue&type=style&index=0&id=243d8da4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports